export type TreeRoot = {
  nodeKey?: string
  nodeValue?: number
}

export const IgnoredTreeKeys = ['id', '__typename', 'nodeKey', 'nodeValue']
